import { createContext } from "react";
import { TableContextState } from "./tableContext.types";

const defaultState: TableContextState = {
  isResizable: false,
  enableSelectRow: false,
};

export const TableContext = createContext<TableContextState>(defaultState);
